import { Instance, flow, types } from 'mobx-state-tree';

import { deleteMedia } from '@common/api/media';
import { getCgCoordinator, removeCgCoordinator, saveCgCoordinator } from '@common/api/cgCoordinators';
import User from '@common/models/Users/User';

const CgCoordinator = types
	.compose(
		User,
		types.model({
			phone: types.maybeNull(types.string),
			position: types.maybeNull(types.string),
			personal_number: types.maybeNull(types.string),
			zoom_link: types.maybeNull(types.string),
			zoom_id: types.maybeNull(types.string),
			zoom_access_code: types.maybeNull(types.string),
			zoom_on_off: types.maybeNull(types.number),
			miro_link: types.maybeNull(types.string),
			job_title: types.maybeNull(types.string),
			can_impersonate: types.maybeNull(types.boolean),
		}),
	)
	.named('CgCoordinator')
	.actions(() => ({
		_fetch: getCgCoordinator,
		_save: saveCgCoordinator,
		_remove: removeCgCoordinator,
	}))
	.actions((self) => ({
		deleteAvatar: flow(function* () {
			yield deleteMedia({ id: self.user_id, entity: 'users', media_collection: 'avatar' });
			yield self._fetch(self.id);
		}),
	}));

export default CgCoordinator;

export interface ICgCoordinatorModel extends Instance<typeof CgCoordinator> {}
